import ReactGA from 'react-ga4';

export default function useGoogleAnalytics() {
  ReactGA.initialize('G-7L17082Z4X');

  return null;
}